// @ts-check

/**
 * Enumerated type for production locations.
 * @type {typeof import('@erpagroapp/types').TipoLugarProduccion}
 */
export const TipoLugarProduccion = Object.freeze({
  NoAplica: 0,
  LineaProduccion: 1,
  Finca: 2,
  Cultivo: 3,
  Proveedor: 4,
  Direccion: 5,
});

/**
 * Enumerated type for palletizing points productuon status.
 * @type {typeof import('@erpagroapp/types').TipoEstadoProduccionPuntoPaletizado}
 */
export const TipoEstadoProduccionPuntoPaletizado = Object.freeze({
  EnCola: 0,
  EnProduccion: 1,
  Detenido: 2,
  Producido: 3,
});

/**
 * Enumerated type for order lines production status.
 * @type {typeof import('@erpagroapp/types').TipoLineaProduccionPedidoSituacion}
 */
export const TipoLineaProduccionPedidoSituacion = Object.freeze({
  Previsto: 0,
  Retrasado: 1,
  Critico: 2,
});

/**
 * Enumerated type for production locations.
 * @type {typeof import('@erpagroapp/types').TipoEntidadPrioridadProduccion}
 */
export const TipoEntidadPrioridadProduccion = Object.freeze({
  NoAplica: 0,
  Cliente: 1,
  Pais: 2,
  TipoCliente: 3,
});

/**
 * Enumerated type for estimated yield types.
 * @type {typeof import('@erpagroapp/types').TipoCalculoRendimiento}
 */
export const TipoCalculoRendimiento = Object.freeze({
  Estandar: 0,
  Historico: 1,
});
